type AppError = {
  name?: string;
  message?: string;
};

export const getErrorName = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  return (error as { name?: string }).name;
};

export const isAmplifyError = (error: unknown, name: string): boolean => {
  return getErrorName(error) === name;
};

// NOTE: 必要であれば日本語メッセージはlocaleファイル等に委譲してください
export const getAmplifyErrorMessage = (error: unknown): string => {
  if (typeof error !== 'object' || error === null) {
    return '不明なエラー';
  }
  const e = error as AppError;

  switch (getErrorName(error)) {
    case 'NotAuthorizedException':
      return 'メールアドレスまたはパスワードが正しくありません。';

    case 'UserNotFoundException':
      return 'ユーザーが存在しません。';

    case 'UserNotConfirmedException':
      return 'ユーザー確認が完了していません。';

    case 'CodeMismatchException':
      return '認証コードが正しくありません。';

    case 'ExpiredCodeException':
      return '認証コードの有効期限が切れています。';

    case 'LimitExceededException':
      return '試行回数が多すぎます。しばらくしてから再度お試しください。';

    case 'TooManyRequestsException':
      return 'リクエストが多すぎます。しばらくしてから再度お試しください。';

    default:
      return e.message ?? '不明なエラー';
  }
};
